<template>
  <div
    class="trustpilot-widget"
    :data-locale="local"
    :data-template-id="templateId"
    :data-businessunit-id="businessunitId"
    :data-style-height="height"
    :data-style-width="width"
    :data-theme="theme"
    :data-stars="stars"
  >
    <a
      :href="linkUrl"
      target="_blank"
      rel="noopener"
      v-text="linkText"
    />
    <template
      v-if="loadTrustpilot"
    >
      <script-loader
        :src="jsUrl"
      />
    </template>
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import ScriptLoader from '../scriptLoader/scriptLoader.vue';

  @Options({
    name: 'trustpilot-widget',
    components: {
      ScriptLoader
    }
  })
  export default class TrustpilotWidget extends Vue {
    @Prop()
    readonly jsUrl: string;
    @Prop()
    readonly templateId: string;
    @Prop()
    readonly businessunitId: string;
    @Prop()
    readonly linkUrl: string;
    @Prop()
    readonly stars: string;
    @Prop({default: 'de-DE'})
    readonly local: string;
    @Prop({default: 'Trustpilot'})
    readonly linkText: string;
    @Prop({default: 'light'})
    readonly theme: string;
    @Prop({default: '100%'})
    readonly width: string;
    @Prop({default: '150px'})
    readonly height: string;

    loadTrustpilot: boolean = false;

    mounted() {
      this.loadTrustpilot = true;
    }
  }
</script>
